module.exports = __webpack_public_path__ + "static/media/banner-bg-1.1c57af50.jpg";